(function () {
  function getVariantsData() {
    const el = document.getElementById('uvp-variants-json');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent).variants;
    } catch {
      return null;
    }
  }

  function getCurrentVariantId() {
    const input = document.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function updateUVP() {
    const wrapper = document.querySelector('.uvp-wrapper');
    const percentEl = document.querySelector('.uvp-percent');
    if (!wrapper || !percentEl) return;

    const variants = getVariantsData();
    const currentId = getCurrentVariantId();

    if (!variants || !currentId) {
      wrapper.hidden = true;
      return;
    }

    const variant = variants.find(v => v.id === currentId);
    if (!variant || !variant.uvp) {
      wrapper.hidden = true;
      return;
    }

    const price = variant.price / 100;
    const uvp = parseFloat(variant.uvp);

    if (price >= uvp) {
    wrapper.hidden = true;
    return;
    }

    const percent = Math.round(((uvp - price) / uvp) * 100);
    if (percent <= 0) {
    wrapper.hidden = true;
    return;
    }


    // Prozent setzen
    percentEl.textContent = percent + ' %';

    // UVP Betrag setzen
    const amountEl = wrapper.querySelector('.uvp-amount');
    if (amountEl) {
    const uvpFormatted = new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(uvp);
    amountEl.textContent = uvpFormatted;
    }

    wrapper.hidden = false;
  }

  // Initial
  document.addEventListener('DOMContentLoaded', updateUVP);

  // Klassisch
  document.addEventListener('change', updateUVP);

  // Für Themes mit Custom Variant JS
  document.addEventListener('variant:change', updateUVP);

  // Safety: falls Theme still & silent updated
  setTimeout(updateUVP, 300);
})();
